module.exports = __webpack_public_path__ + "4f46be41435ec190eccb1e819229df7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/TechSkills/icons/mongoDB.png
// module id = 48
// module chunks = 0